import { themeColors, transitionTime } from '@hg/stylizator/utils'
import * as React from 'react'
import Select, { ValueType } from 'react-select'

import { IOption } from 'app/components/DropDown'

interface IProps {
  name: string
  options: IOption[]
  selectValue: ValueType<IOption, false>
  setSelectValue: (value: ValueType<IOption, false>) => void
}

const DropDownComponent: React.FC<IProps> = (props) => {
  const customStyles = {
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      height: 48,
      fontSize: 16,
      padding: '0 16px',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      color: themeColors.gray['90'],
      padding: 8,
      paddingLeft: 16,
      cursor: 'pointer',
      backgroundColor: state.isSelected || state.isFocused ? themeColors.gray['10'] : 'white',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: 8,
      height: 48,
      cursor: 'pointer',
      borderColor: state.menuIsOpen ? themeColors.blue['50'] : themeColors.gray['30'],
      borderBottomColor: state.menuIsOpen ? themeColors.gray['30'] : undefined,
      backgroundColor: state.menuIsOpen ? 'white' : themeColors.gray['5'],
      outline: state.isFocused ? 'none' : state.outline,
      boxShadow: state.isFocused && !state.menuIsOpen ? `0 0 0 4px ${themeColors.blue['30']}` : state.boxShadow,
      borderBottomRightRadius: state.menuIsOpen ? 0 : undefined,
      borderBottomLeftRadius: state.menuIsOpen ? 0 : undefined,
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      borderRadius: 8,
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      marginTop: -1,
      borderColor: themeColors.blue['50'],
      borderTopColor: themeColors.gray['30'],
      borderWidth: 1,
      borderStyle: 'solid',
      boxShadow: 'none',
      overflow: 'hidden',
    }),
    placeholder: (provided: any, state: any) => ({
      ...provided,
      lineHeight: 24,
      paddingLeft: 16,
      height: 48,
      padding: 12,
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
      transformOrigin: '18px 18px',
      paddingBottom: 10,
      transition: `${transitionTime}s`,
    }),
  }

  return (
    <Select
      styles={customStyles}
      name={props.name}
      value={props.selectValue}
      onChange={(val) => props.setSelectValue(val)}
      options={props.options}
      isSearchable={false}
    />
  )
}

export default DropDownComponent
